import { combineReducers, configureStore } from "@reduxjs/toolkit";
import {
  useDispatch,
  useSelector,
  useStore,
  TypedUseSelectorHook,
} from "react-redux";
import menuItemReducer from "./menuItem/menuItemReducer";
import planReducer from "./plan/planReducer";
import mapReducer from "./map/mapReducer";
import sessionReducer from "./sessionReducer";
import datePickerReducer from "./datePickerReducer";
import toastReducer from "./toastReducer";
import planRouteReducer from "./planRouteReducer";
import { api } from "./services/api";
import { backendApi } from "./services/backend/backendApi";
import mediaReducer from "./media/mediaReducer";
import kioskReducer from "./kiosk/kioskReducer";
import clientLinksReducer from "./clientLinks/clientLinksReducer";
import clientReducer from "./client/clientReducer";
import adReducer from "./ad/adReducer";
import appReducer from "./app/appReducer";
import tripBuilderReducer from "./tripBuilder/tripBuilderReducer";
import locationReducer from "./location/locationReducer";

const rootReducer = combineReducers({
  [api.reducerPath]: api.reducer,
  [backendApi.reducerPath]: backendApi.reducer,
  menuItem: menuItemReducer,
  plan: planReducer,
  map: mapReducer,
  session: sessionReducer,
  datePicker: datePickerReducer,
  toast: toastReducer,
  planRoute: planRouteReducer,
  media: mediaReducer,
  kiosk: kioskReducer,
  clientLinks: clientLinksReducer,
  client: clientReducer,
  ad: adReducer,
  app: appReducer,
  tripBuilder: tripBuilderReducer,
  location: locationReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export const setupStore = (preloadedState?: Partial<RootState>) => {
  const storeResult = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) => {
      return getDefaultMiddleware().concat(
        api.middleware,
        backendApi.middleware,
      );
    },
    preloadedState,
  });

  return storeResult;
};

const store = setupStore();

export type AppDispatch = typeof store.dispatch;
export type AppStore = typeof store;

export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
export const useAppStore: () => AppStore = useStore;

export { store };
